module.exports = __webpack_public_path__ + "img/right-info-open03.d73b454a.png";